<div class="container-login p-2 px-3">
  <div class="d-flex align-items-center">
    <div class="col d-flex justify-content-start">
      <img
        src="../../../../assets/img/common/login-montra-logo.svg"
        class="logo-left"
        alt="Montra One"
      />
    </div>
    <div class="col d-flex justify-content-end">
      <img
        src="../../../../assets/img/common/montra-electric.svg"
        class="logo-right"
        alt="Montra Electric"
      />
    </div>
  </div>

  <div class="row me-5 mt-1">
    <div
      class="col-lg-7 d-flex flex-column justify-content-start align-items-center text-section"
    >
      <div class="heading-1">Electrifying your drive</div>
      <div class="heading-2">Maximizing your savings</div>
      <div class="heading-3">Every Mile, Every Vehicle</div>
    </div>
    <div
      class="col-lg-5 d-flex justify-content-end align-items-baseline main-container"
    >
      <div class="form-container">
        <h3 class="form-head">Email</h3>
        <h6 class="form-sub-head">
          To reset your password, enter your Email. password reset details will
          be sent to your registered Email.
        </h6>
        <form
          [formGroup]="verifyLinkForm"
          class="form-signin"
          (ngSubmit)="verifyEmail()"
        >
          @for (msg of messages; track $index) {
            <p-message [severity]="$any(msg.severity)" [closable]="true">{{
              msg.summary
            }}</p-message>
          }
          <div class="input-1">
            <input
              type="email"
              id="inputEmail"
              name="useremail"
              pInputText
              formControlName="useremail"
              class="form-control"
              placeholder="Email address"
              [ngClass]="{
                'ng-invalid ng-dirty':
                  verifyLinkForm.get('useremail')?.invalid &&
                  verifyLinkForm.get('useremail')?.touched,
              }"
              autocomplete="username"
            />
            <small
              class="p-error block"
              *ngIf="
                verifyLinkForm.get('useremail')?.hasError('required') &&
                verifyLinkForm.get('useremail')?.touched
              "
              >Email is required.</small
            >
            <small
              class="p-error block"
              *ngIf="
                verifyLinkForm.get('useremail')?.hasError('pattern') &&
                verifyLinkForm.get('useremail')?.touched
              "
              >Please enter a valid email address.</small
            >
          </div>
          <div class="input-captcha">
            <app-google-recaptcha
              id="recaptcha"
              formControlName="captcha"
              [siteKey]="siteKey"
              [theme]="'light'"
              [size]="'normal'"
            >
            </app-google-recaptcha>
            <div
              *ngIf="
                verifyLinkForm.get('captcha')?.invalid &&
                (verifyLinkForm.get('captcha')?.dirty ||
                  verifyLinkForm.get('captcha')?.touched)
              "
            >
              <small
                class="p-error block"
                *ngIf="verifyLinkForm.get('captcha')?.hasError('required')"
                >Captcha is required</small
              >
            </div>
          </div>
          <button class="button-submit" type="submit" [disabled]="loading">
            {{ loading ? 'Loading...' : 'Verify Email' }}
          </button>
          <div class="input-3 justify-content-center">
            <a routerLink="/login" class="forgot-password"> Back to login </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
